export default "__VITE_ASSET__DgCdyhul__"